import {availabilityDisplayNoOfNightsChange} from '../actions/AvailabilityActions';
import {connect} from 'react-redux';
import AppComponent from "../components/AppComponent";
import AppComponentMobile from "../components/mobile/AppMobileComponent";
import AvailabilitySearchComponent
  from "../components/AvailabilitySearchComponent";

const mapStateToProps = state => {
  return {
   muiTheme : state.availabilityReducer.muiTheme
  }
};

const mapDispatchToProps = dispatch => {
  return {
    onDisplayNoOfNightsChange : noOfNights => {
      dispatch(availabilityDisplayNoOfNightsChange(noOfNights))
    }
  }
};

export const App = connect(mapStateToProps, mapDispatchToProps) (AppComponent);
export const AppMobile = connect(mapStateToProps, mapDispatchToProps) (AppComponentMobile);
export const AvailabilitySearch = connect(mapStateToProps, mapDispatchToProps) (AvailabilitySearchComponent);


// WEBPACK FOOTER //
// ./src/containers/App.js